import React, { memo } from "react";

interface CircularProgressProps {
	percentage: number;
	size?: number;
	textColor?: string;
	trackColor?: string;
}

const CircularProgress: React.FC<CircularProgressProps> = memo(({
	percentage,
	size = 60,
	textColor = "#ffffff",
	trackColor = "rgba(255, 255, 255, 0.2)",
}) => {
	const clamped = Math.max(0, Math.min(100, percentage));
	const strokeWidth = size * 0.1;
	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;
	const dashOffset = circumference * (1 - clamped / 100);
	const cx = size / 2;
	const cy = size / 2;
	const fontSize = size * 0.29;

	return (
		<svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ display: "block" }}>
			<circle
				cx={cx}
				cy={cy}
				r={radius}
				fill="none"
				stroke={trackColor}
				strokeWidth={strokeWidth}
			/>
			<circle
				cx={cx}
				cy={cy}
				r={radius}
				fill="none"
				stroke="#FFB400"
				strokeWidth={strokeWidth}
				strokeDasharray={circumference}
				strokeDashoffset={dashOffset}
				strokeLinecap="round"
				transform={`rotate(-90 ${cx} ${cy})`}
			/>
			<text
				x={cx}
				y={cy}
				textAnchor="middle"
				dominantBaseline="central"
				style={{ fontSize, fontWeight: 700, fontFamily: "Inter, sans-serif", fill: textColor }}
			>
				{clamped}%
			</text>
		</svg>
	);
});

export default CircularProgress;
